import { createEvent } from '@pass-frontend/utility/event-bus';

export const ANALYTICS_REQUEST = createEvent<{
  pageName: string;
  pageTags: Record<string, any>;
}>('analytics/log/request');
